import React from 'react'
import {Navigate} from 'react-router'
import {useSearchParams} from 'react-router-dom'
import HomePage from '../@e_pages/home.page'
import DemoStyledPage from '../@e_pages/demo_styled.page'
import LoginPage from '../@e_pages/login.page'
//<<< 27/10/2023 - SteveF - DO369719 - Added TinyURL Support
import TinyURLPage from '../@e_pages/tinyurl.page'
//>>> 27/10/2023 - SteveF - DO369719 - Added TinyURL Support
import NotFoundAtom from '../@atoms/to_content/not_found/not_found.atom'
import InternalServerErrorAtom from '../@atoms/to_content/internal_server_error/internal_server_error.atom'
import utils from '../utils'

const LoginRedirect = function () {
  return <Navigate replace to="/login" />
}

const PrivateRoute: React.FC = function ({children}) {
  const [searchParams] = useSearchParams()
  const orderGUID = searchParams.get('orderGUID') || ''
  const isLoggedIn = !!utils.getTokenBasedOnOrderGUID(orderGUID)

  return isLoggedIn ? (
    (children as React.ReactElement)
  ) : (
    <Navigate replace to={`/login?orderGUID=${orderGUID}`} />
  )
}

const AuthRoute: React.FC = function ({children}) {
  const [searchParams] = useSearchParams()
  const orderGUID = searchParams.get('orderGUID') || ''
  const isLoggedIn = !!utils.getTokenBasedOnOrderGUID(orderGUID)

  return !isLoggedIn ? (
    (children as React.ReactElement)
  ) : (
    <Navigate replace to={`/my-orders?orderGUID=${orderGUID}`} />
  )
}

const routesList = [
  {path: '/', element: () => <LoginRedirect />},
  {
    path: '/my-orders',
    element: () => (
      <PrivateRoute>
        <HomePage />
      </PrivateRoute>
    ),
  },
  {path: '/demostyled', element: () => <DemoStyledPage />},
  {
    path: '/login',
    element: () => (
      <AuthRoute>
        <LoginPage />
      </AuthRoute>
    ),
  },
  {path: '/notFound', element: () => <NotFoundAtom />},
  {path: '/500', element: () => <InternalServerErrorAtom />},
  //<<< 27/10/2023 - SteveF - DO369719 - Added TinyURL Support
    { path: '*', element: () => <TinyURLPage /> },
  //>>> 27/10/2023 - SteveF - DO369719 - Added TinyURL Support
]

export default routesList
